<template>
  <div class="ro-login account-box">
    <div class="ro-login-title">
      {{ letter.selectLoginType }}
    </div>

    <!-- 二维码+三方登录模式 (主界面) -->
    <!-- 掃碼登錄 -->
    <div class="qrcode-login-section" v-if="!onlyThirdPartyLogin">
      <div class="section-title">
        {{ letter.v3ScanCodeLogin || '掃碼登錄' }}：
      </div>
      <div class="qrcode-container">
        <div class="qrcode-box">
          <img
            v-if="qrCodeUrl"
            :src="qrCodeUrl"
            alt="二維碼"
            class="qrcode-img"
          />
          <div v-if="isInitializing || qrCodeLoading" class="qrcode-loading">
            <div class="loading-icon"></div>
            <div class="qrcode-text">
              {{ letter.v3ScanLoading || '加載中...' }}
            </div>
          </div>
          <div
            v-if="qrStatus === QRCodeStatus.EXPIRED && !qrCodeLoading"
            class="qrcode-expired"
            @click="refreshQRCode"
          >
            <div class="qrcode-text">
              {{ letter.v3ScanExpired || '二維碼已過期' }}
            </div>
            <div class="qrcode-text">
              {{ letter.v3ScanRefreshClick || '點擊刷新' }}
            </div>
            <div class="qrcode-text">
              <div class="refresh-icon"></div>
              {{ letter.v3ScanRefresh || '刷新' }}
            </div>
          </div>
          <div v-if="qrStatus === QRCodeStatus.SCANNED" class="qrcode-scanned">
            <div class="qrcode-text">{{ letter.v3ScanSucc || '掃碼成功' }}</div>
            <div class="qrcode-text">
              {{ letter.v3ScanAuth || '請在手機上確認' }}
            </div>
          </div>
          <div
            v-if="qrStatus === QRCodeStatus.CONFIRMED"
            class="qrcode-confirmed"
          >
            <div class="qrcode-text">
              {{ letter.v3ScanAuthSuccess || '授權成功' }}
            </div>
            <div class="qrcode-text">
              {{ letter.v3ScanAuthSuccessTip || '正在登錄...' }}
            </div>
          </div>
          <div
            v-if="qrStatus === QRCodeStatus.UNAUTHORIZED && !qrCodeLoading"
            class="qrcode-expired"
            @click="refreshQRCode"
          >
            <div class="qrcode-text">
              {{ letter.v3ScanUnauthorized || '已拒絕授權' }}
            </div>
            <div class="qrcode-text">
              {{ letter.v3ScanRefreshTip || '請重新掃碼' }}
            </div>
            <div class="qrcode-text">
              <div class="refresh-icon"></div>
              {{ letter.v3ScanRefresh || '刷新' }}
            </div>
          </div>
        </div>
        <div class="qrcode-tip">
          {{ letter.v3ScanRefreshTip2 || '請打開遊戲登錄後掃碼登錄' }}
        </div>
        <div class="qrcode-actions">
          <a
            href="javascript:;"
            class="action-link"
            @click="!qrCodeLoading && refreshQRCode()"
          >
            <span class="refresh-icon-small"></span>
            {{ letter.v3ScanRefresh || '刷新' }}
          </a>
          <span class="divider">|</span>
          <a href="javascript:;" class="action-link scan-guide-btn">
            {{ letter.v3ScanGuide || '掃碼指引' }}
            <div class="scan-guide" :class="{ 'en-US': +gameId === 456 }"></div>
          </a>
        </div>
      </div>
    </div>

    <!-- 第三方登錄 -->
    <div class="third-party-login-section">
      <div class="section-title" v-if="!onlyThirdPartyLogin">
        {{ letter.v3ThirdPartyLogin || '第三方登錄' }}：
      </div>
      <div class="other-login">
        <div
          v-for="(item, index) in filteredThirdList"
          :key="index"
          class="third-box j-third-part-login"
        >
          <a
            class="login-type"
            href="javascript:;"
            :class="`j-${item}-login-btn ${$platformClass}`"
            @click="loginHrefJump(loginHref[item], false, item)"
          >
            <i :class="item"></i>
            <p class="name">{{ channelName[item] }}</p>
          </a>
        </div>
      </div>
    </div>

    <button
      v-if="!onlyThirdPartyLogin"
      class="account-info j-account-info"
      @click="showAccountLoginPopup"
    >
      {{ letter.v3NoMyLoginMethod || '沒有我的登錄方式？' }}
    </button>

    <!-- 账号密码登录弹窗 -->
    <transition name="fade">
      <div
        class="account-login-popup"
        v-if="showAccountPopup"
        @click.self="closeAccountPopup"
      >
        <div class="popup-content">
          <div class="popup-header">
            <h3 class="popup-title">
              {{ letter.v3AccountPasswordLogin || '賬號密碼登錄' }}
            </h3>
            <a
              href="javascript:;"
              class="popup-close"
              @click="closeAccountPopup"
            >
              <span class="close-icon">×</span>
            </a>
          </div>
          <div class="popup-body">
            <label class="input-box box" :class="{ err: userAccountTips }">
              <span class="label">{{ letter.accountLabel }}：</span>
              <input
                v-model="userAccount"
                class="input"
                type="text"
                :class="{ err: userAccountTips }"
                @blur="judgeUserAccount()"
                :placeholder="letter.accountName"
              />
            </label>
            <p class="tips j-username-tip" v-if="userAccountTips">
              {{ userAccountTips }}
            </p>
            <label
              class="input-box password-box box"
              :class="{ err: userPasswordTips }"
            >
              <span class="label">{{ letter.passwordLabel }}：</span>
              <input
                v-model="userPassword"
                class="input"
                type="password"
                :class="[userPasswordTips ? 'err' : false, $platformClass]"
                @blur="judgeUserPassword()"
                :placeholder="letter.password"
              />
            </label>
            <p class="tips j-password-tip" v-if="userPasswordTips">
              {{ userPasswordTips }}
            </p>
            <div class="remember box">
              <div>
                <i class="goukuang j-remember-me" @click="toggleRemember">
                  <i class="gou" v-show="isRemember"></i>
                </i>
                <span class="text j-remember-me" @click="toggleRemember">
                  {{ letter.remember }}
                </span>
              </div>

              <a
                :href="findPwd"
                target="_blank"
                class="forget j-forget-pwd"
                v-if="!musVn"
              >
                {{ letter.forgetPwd }}
              </a>
            </div>
            <!-- 谷歌验证码：白名单游戏且风控触发后展示 -->
            <div
              class="g-recaptcha"
              v-show="isOpenGv"
              id="ro-login-recaptcha"
            ></div>
            <div class="btn-wrap">
              <a
                href="javascript:void(0);"
                class="btn login-btn j-login-btn"
                pointClass="j-login-btn"
                :loading="loading"
                @click="login"
              >
                <span>{{ letter.login }}</span>
                <i
                  v-show="loading"
                  class="loading light"
                  style="margin-left: 1vh"
                ></i>
              </a>
              <p class="tips j-request-tip request-tip">
                {{ loginRequestTips }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script type="text/javascript">
import {
  CHANNEL_NAME,
  UPDATE_LOGIN_REQUEST
} from '../../store/web/login.js';
import login from '../../mixins/Login.js';
import qrCodeLogin from '../../mixins/webLogin/qrCodeLogin.js';
import globalConfig from '../../utiles/globalConfig.js';
import { reportActivityPoint, reportRecaptchaActivityPoint } from '../../utiles/webLogin/activityPoint.js';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import {
  RECAPTCHA_SITE_KEY,
  OPEN_GV_GAME_IDS,
  RECAPTCHA_RISK_ERROR_CODES,
  RECAPTCHA_COOKIE_KEY
} from '../../configs/recaptcha';
const mainHost = globalConfig.getMainHost();

export default {
  name: 'accountLoginPage',
  mixins: [login, qrCodeLogin],
  data() {
    return {
      channelName: CHANNEL_NAME,
      showThirdPart: globalConfig.getHrefParam('noThridPart') !== '1',
      // 初始化时就设置为 true，确保显示加载状态
      isInitializing: true,
      // 账号密码登录弹窗显示状态
      showAccountPopup: false,
      /** 是否因风控需要展示验证码 */
      isShowRecaptcha: false,
      /** 验证码是否已过期（点击登录时再提示） */
      isRecaptchaExpired: false
    };
  },
  computed: {
    findPwd() {
      let gameId =
        this.$store.state.gameId || globalConfig.getHrefParamUndecode('gameId');
      return getGlobalGetGotoLink({
        link: `https://pay.${mainHost}/platform/passport.html?gameId=${gameId}&appLanguage=${this.$store.state.lang}&language=${this.$store.state.lang}#/findPwd`
      });
    },
    letter() {
      return this.$store.state.letter;
    },
    lang() {
      return this.$store.state.lang;
    },
    // 过滤三方登录列表，只保留 Facebook 和 Google
    filteredThirdList() {
      return this.thirdList.filter(item =>
        ['facebook', 'googleplay'].includes(item)
      );
    },
    // 链接 onlyThirdParty=1 时仅展示第三方登录
    onlyThirdPartyLogin() {
      return globalConfig.getHrefParam('onlyThirdParty') === '1';
    },
    /** 白名单游戏且（已触发风控或 Cookie 有效）时展示验证码 */
    isOpenGv() {
      if (!OPEN_GV_GAME_IDS.includes(+this.gameId)) {
        return false;
      }
      return (
        this.isShowRecaptcha || !!globalConfig.getCookie(RECAPTCHA_COOKIE_KEY)
      );
    }
  },
  watch: {
    // 监听二维码URL的变化，一旦生成就关闭初始化状态
    qrCodeUrl(newVal) {
      if (newVal) {
        this.isInitializing = false;
      }
    },
    // 监听二维码状态：错误态关闭初始化；扫码成功 / 授权成功上报埋点
    qrStatus(newVal, oldVal) {
      if (
        newVal === this.QRCodeStatus.EXPIRED ||
        newVal === this.QRCodeStatus.UNAUTHORIZED
      ) {
        this.isInitializing = false;
      }
      // 已扫码，待授权（仅状态首次进入时上报，轮询不会重复）
      if (newVal === this.QRCodeStatus.SCANNED && oldVal !== newVal) {
        reportActivityPoint('qrcode_scan_success', {
          gameId: this.gameId,
          eventType: 'qrcode_login'
        });
      }
      // 已授权确认（随后进入登录接口）
      if (newVal === this.QRCodeStatus.CONFIRMED && oldVal !== newVal) {
        reportActivityPoint('qrcode_auth_success', {
          gameId: this.gameId,
          eventType: 'qrcode_login'
        });
      }
      // 用户拒绝授权
      if (newVal === this.QRCodeStatus.UNAUTHORIZED && oldVal !== newVal) {
        reportActivityPoint('qrcode_unauthorized', {
          gameId: this.gameId,
          eventType: 'qrcode_login'
        });
      }
    },
    // 监听 gameId 的变化，一旦有值就初始化二维码
    gameId(newVal) {
      if (newVal && !this.qrCodeUrl) {
        this.initQRCodeLogin();
      }
    },
    // 弹窗已打开且需要验证码时加载 SDK
    isOpenGv(open) {
      if (open && this.showAccountPopup) {
        this.$nextTick(() => {
          this.loadRecaptchaScript();
        });
      }
    },
    // 打开账密弹窗时，若 Cookie 仍有效则直接展示验证码
    showAccountPopup(open) {
      if (open && this.isOpenGv) {
        reportRecaptchaActivityPoint(
          'google_recaptcha_trigger',
          { msg: 'init' }
        );
        this.$nextTick(() => {
          this.loadRecaptchaScript();
        });
      }
    }
  },
  mounted() {
    // gameId 已经存在，则立即初始化二维码
    // 否则等待 watch 中的 gameId 监听器触发
    if (this.gameId) {
      this.initQRCodeLogin();
    }
  },
  beforeDestroy() {
    window.googleVerificationWidget = undefined;
    window.googleVerificationToken = '';
  },
  methods: {
    showAccountLoginPopup() {
      this.showAccountPopup = true;
      reportActivityPoint('open_account_login', {
        eventType: 'account_login',
        eventReason: 'click_button',
        eventValue: { with_recaptcha: this.isOpenGv ? 1 : 0 }
      });
    },
    closeAccountPopup() {
      this.showAccountPopup = false;
      // 弹窗 v-if 销毁 DOM 后，旧 widget id 已失效，需清除以免重开时无法 render
      window.googleVerificationWidget = undefined;
      window.googleVerificationToken = '';
    },
    loginHrefJump(href, target, channel) {
      reportActivityPoint('third_party_login_click', {
        gameId: this.gameId,
        eventReason: 'click_button',
        eventType: 'third_party_login',
        eventValue: { channel, target }
      })
      if (this.runInIframe) {
        window.parent.postMessage(
          {
            action: 'openThirdLoginLink',
            url: href
          },
          '*'
        );
      } else {
        window.open(href, target ? '_blank' : '_self');
      }
    },
    /** 未完成 / 已过期时的提示文案 */
    getRecaptchaTip(isExpired) {
      return isExpired
        ? this.letter.recaptchaExpired
        : this.letter.completeRecaptcha;
    },
    /** 在容器 DOM 就绪后渲染验证码 */
    renderRecaptcha() {
      const container = document.getElementById('ro-login-recaptcha');
      if (!container || !window.grecaptcha) return;

      const self = this;
      container.innerHTML = '';
      window.googleVerificationToken = '';
      window.googleVerificationWidget = undefined;

      window.grecaptcha.ready(() => {
        const readyContainer = document.getElementById('ro-login-recaptcha');
        if (!readyContainer) return;
        window.googleVerificationWidget = window.grecaptcha.render(
          readyContainer,
          {
            sitekey: RECAPTCHA_SITE_KEY,
            callback(token) {
              window.googleVerificationToken = token;
              self.isRecaptchaExpired = false;
              reportRecaptchaActivityPoint('google_recaptcha_pass');
            },
            'error-callback'(err) {
              window.googleVerificationToken = '';
              reportRecaptchaActivityPoint('google_recaptcha_fail', {
                reason: 'error',
                msg: err?.msg || ''
              });
            },
            'expired-callback'(err) {
              window.googleVerificationToken = '';
              self.isRecaptchaExpired = true;
              reportRecaptchaActivityPoint('google_recaptcha_fail', {
                reason: 'expired',
                msg: err?.msg || ''
              });
              if (
                window.grecaptcha &&
                window.googleVerificationWidget !== undefined
              ) {
                window.grecaptcha.reset(window.googleVerificationWidget);
              }
            }
          }
        );
      });
    },
    /** 清空 token 并重置验证码组件 */
    resetRecaptcha() {
      window.googleVerificationToken = '';
      if (
        window.grecaptcha &&
        window.googleVerificationWidget !== undefined
      ) {
        window.grecaptcha.reset(window.googleVerificationWidget);
        return;
      }
      this.renderRecaptcha();
    },
    /** 加载 reCAPTCHA SDK，验证通过后 token 写入 window.googleVerificationToken */
    loadRecaptchaScript() {
      const self = this;

      if (window.grecaptcha) {
        this.renderRecaptcha();
        return;
      }

      const loadLang = this.lang || 'en-US';
      const existingScript = document.querySelector(
        'script[src*="google.com/recaptcha/api.js"]'
      );
      if (existingScript) {
        this.renderRecaptcha();
        return;
      }

      window.onRoLoginRecaptchaLoad = () => {
        self.renderRecaptcha();
      };
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.google.com/recaptcha/api.js?onload=onRoLoginRecaptchaLoad&render=explicit&hl=${loadLang}`;
      script.onerror = (error) => {
        reportRecaptchaActivityPoint('google_recaptcha_fail', {
          reason: 'script_load',
          msg: error?.msg || ''
        });
      };
      document.head.appendChild(script);
    },
    /** 是否为要求人机验证的风控错误码 */
    isRecaptchaRiskError(res) {
      const msg = String(res?.msg || '');
      return RECAPTCHA_RISK_ERROR_CODES.some(riskCode =>
        msg.includes(riskCode)
      );
    },
    clearRecaptchaCookie() {
      globalConfig.setCookie(
        RECAPTCHA_COOKIE_KEY,
        '',
        new Date(0).toUTCString()
      );
    },
    /** mixin login 提交前钩子：未完成人机验证时拦截 */
    beforeGoLogin() {
      if (this.isOpenGv && !window.googleVerificationToken) {
        this.$store.commit(
          UPDATE_LOGIN_REQUEST,
          this.getRecaptchaTip(this.isRecaptchaExpired)
        );
        return false;
      }
      reportActivityPoint('login_click', {
        eventType: 'account_login',
        eventValue: { with_recaptcha: this.isOpenGv ? 1 : 0 }
      });
      return true;
    },
    /** mixin login 成功后钩子：清理验证码状态 */
    afterGoLoginSuccess() {
      reportActivityPoint('login_success', {
        eventType: 'account_login',
        eventValue: { with_recaptcha: this.isOpenGv ? 1 : 0 }
      });
      this.clearRecaptchaCookie();
      this.isShowRecaptcha = false;
      window.googleVerificationToken = '';
    },
    /** mixin login 失败钩子：风控触发时展示验证码；任意失败时重置验证码 */
    onGoLoginFail(loginRes) {
      reportActivityPoint('login_fail', {
        eventType: 'account_login',
        eventValue: { msg: String(loginRes?.msg || '') }
      });
      if (this.isRecaptchaRiskError(loginRes)) {
        this.isShowRecaptcha = true;
        const expireAt = new Date();
        expireAt.setTime(expireAt.getTime() + 60 * 60 * 1000); // 1 小时
        globalConfig.setCookie(
          RECAPTCHA_COOKIE_KEY,
          'true',
          expireAt.toUTCString()
        );
        reportRecaptchaActivityPoint('google_recaptcha_trigger', {
          msg: String(loginRes?.msg || '')
        });
        this.$nextTick(() => {
          this.resetRecaptcha();
        });
        return true;
      }
      // 普通登录失败：已展示验证码时重置，需重新验证
      if (this.isOpenGv) {
        reportRecaptchaActivityPoint('google_recaptcha_trigger', {
          msg: String(loginRes?.msg || '')
        });
        this.$nextTick(() => {
          this.resetRecaptcha();
        });
      }
      return false;
    },
    /**
     * 二维码登录成功后的处理
     * 覆盖 qrCodeLogin mixin 的默认行为
     * 使用后端验证后返回的 forward 参数进行重定向，支持 iframe 模式
     */
    async onQRCodeLoginSuccess(res) {
      console.log('二维码登录成功', res);
      reportActivityPoint('login_success', {
        eventType: 'qrcode_login',
      });

      // 使用后端验证后返回的 forward（安全的跳转地址）
      const redirectUrl = res.forward || window.location.href;

      if (this.runInIframe) {
        window.parent.postMessage(
          {
            action: 'refreshPage',
            url: redirectUrl
          },
          '*'
        );
      } else {
        window.location.href = redirectUrl;
      }
    },
    onQRCodeLoginFail(res) {
      reportActivityPoint('login_fail', {
        eventType: 'qrcode_login',
        eventValue: { msg: String(res?.msg || '') }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/comom.scss';
@import '../../assets/scss/webLogin-v3.scss';

.g-recaptcha {
  margin: 1.2vh 0;
  position: relative;
  display: flex;
  justify-content: flex-start;
  visibility: visible;
}
</style>
